<template>
  <div class="container is-fluid py-5">
    
    <div class="level">
      <div class="level-left tabs is-toggle mb-5 mt-2">
        <ul>
          <li 
            @click="setFilter({ field: 'product_brand', value: null })"
            :class="{ 'is-active': filters.product_brand == null }">
            <a>All</a>
          </li>    
          <li 
            @click="setFilter({ field: 'product_brand', value: 'Cladify' })"
            :class="{ 'is-active': filters.product_brand == 'Cladify' }">
            <a>Cladify</a>
          </li>
          <li 
            @click="setFilter({ field: 'product_brand', value: 'Mitrex' })"
            :class="{ 'is-active': filters.product_brand == 'Mitrex' }">
            <a>Mitrex</a>
          </li>       
        </ul>
      </div>

      <search-autocomplete 
        :value="filters.project_id"
        @input="setFilter({ field: 'project_id', value: $event })"
        class="level-right"
        :product-brand="filters.product_brand"/> 
    </div>
    
    <div class="columns">

      <div class="column columns flex--grow px-4">
        <div class="column is-4 px-1">
          <div class="card card--outlined is-fullheight has-text-centered">
            <div class="card-content task-count px-3 py-3">
              <v-fade-transition mode="out-in">
                <p 
                  :key="rfqSummary.reduce((a,b) => a + b.count, 0)" 
                  class="title is-1 mb-0">
                  {{ rfqSummary.reduce((a,b) => a + b.count, 0) }}
                </p>
              </v-fade-transition>
              <p class="menu-label">
                RFQs
              </p>
            </div>
          </div>
        </div>

        <div class="column is-8 px-1">
          <div class="card card--outlined is-fullheight">
            <div class="card-content px-3 py-3">
              <ul class="menu-list status">
                <li 
                  v-for="status in rfqSummary"
                  :key="status.status"
                  @click="selectedStatuses.rfq = status.status">
                  <a :class="{ 'is-active': selectedStatuses.rfq == status.status }">
                    <div class="status-count mr-2">{{ status.count }}</div>
                    {{ status.status }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="column columns flex--grow px-4">
        <div class="column is-4 px-1">
          <div class="card card--outlined is-fullheight has-text-centered">
            <div class="card-content task-count px-3 py-3">
              <v-fade-transition mode="out-in">
                <p 
                  :key="drawingHighlightSummary.reduce((a,b) => a + b.count, 0)" 
                  class="title is-1 mb-0">
                  {{ drawingHighlightSummary.reduce((a,b) => a + b.count, 0) }}
                </p>
              </v-fade-transition>
              <p class="menu-label">
                Drawing Highlights
              </p>
            </div>
          </div>
        </div>

        <div class="column is-8 px-1">
          <div class="card card--outlined is-fullheight">
            <div class="card-content px-3 py-3">
              <ul class="menu-list status">
                <li 
                  v-for="status in drawingHighlightSummary"
                  :key="status.status"
                  @click="selectedStatuses.drawingHighlight = status.status">
                  <a :class="{ 'is-active': selectedStatuses.drawingHighlight == status.status }">
                    <div class="status-count mr-2">{{ status.count }}</div>
                    {{ status.status }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="column columns flex--grow px-4">
        <div class="column is-4 px-1">
          <div class="card card--outlined is-fullheight has-text-centered">
            <div class="card-content task-count px-3 py-3">
              <v-fade-transition mode="out-in">
                <p 
                  :key="estimationSummary.reduce((a,b) => a + b.count, 0)" 
                  class="title is-1 mb-0">
                  {{ estimationSummary.reduce((a,b) => a + b.count, 0) }}
                </p>
              </v-fade-transition>
              <p class="menu-label">
                Estimations
              </p>
            </div>
          </div>
        </div>

        <div class="column is-8 px-1">
          <div class="card card--outlined is-fullheight">
            <div class="card-content px-3 py-3">
              <ul class="menu-list status">
                <li 
                  v-for="status in estimationSummary"
                  :key="status.status"
                  @click="selectedStatuses.estimation = status.status">
                  <a :class="{ 'is-active': selectedStatuses.estimation == status.status }">
                    <div class="status-count mr-2">{{ status.count }}</div>
                    {{ status.status }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="columns">
      <div class="column is-one-third">
        <rfqs-simple-list :filters="rfqFilters"/>
      </div>

      <div class="column is-one-third">
        <drawing-highlights-simple-list :filters="drawingHighlightFilters"/>
      </div>

      <div class="column is-one-third">
        <estimations-simple-list :filters="estimationFilters"/>
      </div>
    </div>
  </div>
</template>

<script>
import SearchAutocomplete from '@/components/projects/SearchAutocomplete'
import RfqsSimpleList from '@/components/rfq/RfqsSimpleList'
import DrawingHighlightsSimpleList from '@/components/drawingHighlights/DrawingHighlightsSimpleList'
import EstimationsSimpleList from '@/components/estimations/EstimationsSimpleList'
import VFadeTransition from '@/components/transitions/VFadeTransition'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    SearchAutocomplete, RfqsSimpleList, DrawingHighlightsSimpleList, 
    EstimationsSimpleList, VFadeTransition
  },
  data() {
    return {
      active: 'all',
      selectedStatuses: {
        rfq: 'Awaiting Estimator Review',
        drawingHighlight: 'Requested',
        estimation: 'In Progress'
      }
    }
  },
  computed: {
    ...mapState("estimationSummary", [
      "rfqSummary", "drawingHighlightSummary", "estimationSummary", "loading",
      "filters"
    ]),
    ...mapState("auth", ["user"]),
    rfqFilters({ filters }) {
      return {...filters, ...{ status: this.selectedStatuses.rfq }}
    },
    drawingHighlightFilters({ filters }) {
      return {...filters, ...{ status: this.selectedStatuses.drawingHighlight, rfq_status: 'ACCEPTED' }}
    },
    estimationFilters({ filters }) {
      return {...filters, ...{ status: this.selectedStatuses.estimation, rfq_status: 'ACCEPTED', dh_status: 'APPROVED' }}
    }
  },
  watch: {
    filters: {
      handler() {
        this.initialize();
      },
      deep: true
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("estimationSummary", [
      "getRfqSummary", "getDrawingHighlightSummary", "getEstimationSummary"
    ]),
    ...mapMutations("estimationSummary", ["setFilter"]),
    initialize() {
      if (this.user.role == 'sales') {
        this.selectedStatuses.rfq = 'In Progress';
        this.selectedStatuses.drawingHighlight = 'Awaiting Approval';
        this.selectedStatuses.estimation = 'Completed';
      }
      this.getRfqSummary(this.filters);
      this.getDrawingHighlightSummary({ ...this.filters, rfq_status: 'ACCEPTED' });
      this.getEstimationSummary({ ...this.filters, rfq_status: 'ACCEPTED', dh_status: 'APPROVED' });
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/flexbox.scss';

.menu-list.status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  li {
    font-size: 0.85em;
    a {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: silver;
      transition: background 0.5s ease-in-out, color 0.5s ease-in-out;
      &.is-active {
        color: #007aff;
        background: whitesmoke;
      }
    }
    .status-count {
      font-size: 1.2em;
      font-weight: 600;
      width: 30px;
      text-align: right;
    }
  }
}

.card--outlined {
  border: 1px solid gainsboro;
  border-radius: 4px;
  -webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}

.task-count {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.is-fullheight {
  height: 100%;
}

.push-right {
  margin-left: auto;
}
</style>